import { OfficeConsentAdapter } from '../adapters';
import { ConsentsClient } from '../clients';
import type { IOfficeConsent } from '../types/OfficeConsent';
import type { IGetOfficeConsentParameters } from '../types/OfficeConsent.parameters';

export const getOfficeConsent = async (
  params: IGetOfficeConsentParameters,
): Promise<IOfficeConsent> => {
  const apiResponse = await ConsentsClient.getOfficeConsent(params);

  // Transform API response to Domain type
  return OfficeConsentAdapter.toOfficeConsent(apiResponse);
};
